import React, { useState, useEffect } from 'react'
import styled from './index.module.css'
import axios from 'axios'
import useAccountStore from '../../stores/account'
import DefaultHospitalImage from '../../img/hospital.png'
import { BASEURL } from '../../config'

const HospitalInformation = () => {
    const {accessToken} = useAccountStore()
    const [editMode, setEditMode] = useState(false)
    const [prevInfo, setPrevInfo] = useState({
        hospitalName: '안쿠마동물병원',
        phoneNumber: '000-000-0000',
        introduction: '병원 소개 내용',
        openingHours: '병원 영업시간',
        profileImage: '',
        tags:[""] 
    })

    const [userInfo, setUserInfo] = useState({
        hospitalName: '안쿠마동물병원',
        phoneNumber: '000-000-0000',
        introduction: '병원 소개 내용',
        openingHours: '병원 영업시간',
        profileImage: '',
        tags:[""]
    })

    const uploadProfile = async(data: any) => {
        // dataUrl -> Blob -> File로 변환
        const dataUrlToBlob = (dataUrl: string) => {
            const arr = dataUrl.split(',')
            const mime = arr[0].match(/:(.*?);/)![1]
            const bstr = atob(arr[1])
            let n = bstr.length
            let u8arr = new Uint8Array(n)
            while(n--) { u8arr[n] = bstr.charCodeAt(n) }
            return new Blob([u8arr], { type: mime })
        }
        
        const blobToFile = (theBlob: Blob, fileName: string) => {
            const file = new File([theBlob], fileName, { type: theBlob.type })
            return file
        }

        // dataUrl -> Blob -> File로 변환끝

        // upload file to server
        let formData = new FormData()
        const blob = dataUrlToBlob(data)
        const file = blobToFile(blob, 'profileImage')
        formData.append("file", file)

        const url =  await axios.put(`${BASEURL}/auth/upload/profile`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${accessToken}`,
            }
        }).then(response => {
            if (response.data.status === "success") {
                return response.data.data
            } else { return '' }
        }).catch(error => {
            alert(`프로필 사진 업로드 실패: ${error.message}`)
            return ''
        })
        return url
    }
    
    const toggleEditMode = async() => {
        if (editMode) {
            // 수정 완료 버튼을 누를 때의 로직
            // prevInfo와 userInfo를 비교하여 모두 동일한 경우 토글만
            if (JSON.stringify(prevInfo) === JSON.stringify(userInfo)) {
                setEditMode(false)
                return
            }
           
            let updateUrl = ''
            if(userInfo.profileImage !== prevInfo.profileImage) { updateUrl = await uploadProfile(userInfo.profileImage)}
            let updateInfo_ = {
                hospitalName: userInfo.hospitalName,
                phoneNumber: userInfo.phoneNumber,
                introduction: userInfo.introduction,
                openingHours: userInfo.openingHours,
                profileImage: updateUrl,
                // tags: []  // 추후 태그 추가시 사용
            }
            axios.put(`${BASEURL}/auth/update`, {updateInfo: updateInfo_}, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            })

            .then(response => {
                if (response.data.status === "success") {
                    const updateData = response.data.data
                    setUserInfo({
                        hospitalName: updateData.hospitalName,
                        phoneNumber: updateData.phoneNumber,
                        introduction: updateData.introduction,
                        openingHours: updateData.openingHours,
                        profileImage: updateData.profileImage,
                        tags:[]
                    })
                    setPrevInfo({
                        hospitalName: updateData.hospitalName,
                        phoneNumber: updateData.phoneNumber,
                        introduction: updateData.introduction,
                        openingHours: updateData.openingHours,
                        profileImage: updateData.profileImage,
                        tags:[]
                    })
                    setEditMode(false) // 수정 모드 종료
                    alert('병원 정보가 성공적으로 업데이트되었습니다.')
                } else {
                    throw new Error('서버에서 정보 업데이트를 실패했습니다.')
                }
            })
            .catch(error => {
                alert(`병원 정보 업데이트 실패: ${error.message}`)
                setEditMode(true) // 수정 모드 유지
            })
        } else {
            setEditMode(true) // 수정 모드 시작
        }
    }

    const handleChange = (e:any) => {
        const { name, value } = e.target
        setUserInfo(prevState => ({ ...prevState, [name]: value,}))
    }
    
    useEffect(()=> {
        axios.get(`${BASEURL}/auth/me`, { headers: {Authorization: `Bearer ${accessToken}`, }})
        .then(response => response.data)
        .then(obj => {
            if(obj.status === "success") {
                const timestamp = new Date().getTime()
                setPrevInfo({
                    hospitalName: obj.data.info.hospitalName,
                    phoneNumber: obj.data.info.phoneNumber,
                    introduction: obj.data.info.introduction,
                    openingHours: obj.data.info.openingHours,
                    profileImage: obj.data.info.account.profileImage + "?timestamp=" + timestamp,
                    tags:["진료항목1", "진료항목2", "진료항목3"]
                })
                setUserInfo({
                    hospitalName: obj.data.info.hospitalName,
                    phoneNumber: obj.data.info.phoneNumber,
                    introduction: obj.data.info.introduction,
                    openingHours: obj.data.info.openingHours,
                    profileImage: obj.data.info.account.profileImage + "?timestamp=" + timestamp,
                    tags:["진료항목1", "진료항목2", "진료항목3","진료항목1", "진료항목2", "진료항목3","진료항목1", "진료항목2", "진료항목3"]
                })
                
            } else {
                throw new Error(obj.message)
            }
            
        }).catch(error => {
            if(error.response) {
                // temp error handling
                if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
            }
            else {
                console.log(error)
            }
        })
    },[])

    // profile image upload
    const fileInputRef = React.createRef<HTMLInputElement>()
    const changeBtnClick = () => { if (fileInputRef.current) { fileInputRef.current.click() } }
    const cancelBtnClick = () => { setUserInfo(prevState => ({ ...prevState, profileImage: prevInfo.profileImage})) }

    const handleImageChange = (e:any) => {
        const reader = new FileReader()
        const file = e.target.files[0]
        reader.onloadend = () => { setUserInfo( {...userInfo, profileImage:reader.result?.toString()??''}) }
        if (file) { reader.readAsDataURL(file) }
    }
    const setDefaultImage = (e:any) => { e.target.src = DefaultHospitalImage }

    return (
    <div className={styled.container} id={styled.first}>
        <div className={styled.h_info}>
            <div className={styled.top}>
                <span className={styled.tit}>병원정보</span>
                <button className={`${styled.more} ${editMode ? styled.on: ""}`} onClick={toggleEditMode}> {editMode ? "수정완료" : "정보수정" } </button>
            </div>
            <div className={styled.basic}>
                <div className={styled.profile}>
                    <img src={userInfo.profileImage ?? DefaultHospitalImage} alt="" onError={setDefaultImage}/>
                    { editMode ? (<div className={styled.profileBtn}>
                            <button type="button" onClick={changeBtnClick}
                                style={{width:`${prevInfo.profileImage === userInfo.profileImage ? '170px' : '80px'}`}}>
                                사진 변경
                            </button>
                            <button type="button" onClick={cancelBtnClick} style={{
                                display:`${prevInfo.profileImage === userInfo.profileImage ? 'none' : 'block'}`}}>
                                변경 취소
                            </button>
                            <input type="file" ref={fileInputRef} onChange={handleImageChange} />
                        </div>) : <></>}
                </div>
                <div className={styled.basic_con}>
                    <div>
                        <span className={styled.label}>병원이름</span>
                        {editMode ? (
                            <input
                                className={styled.basic_input}
                                type="text"
                                name="hospitalName"
                                value={userInfo.hospitalName}
                                onChange={handleChange}
                            />
                        ) : (
                            <span className={styled.data}>{userInfo.hospitalName}</span>
                        )}
                    </div>
                    <div>
                        <span className={styled.label}>전화번호</span>
                        {editMode ? (
                            <input
                                className={styled.basic_input}
                                type="text"
                                name = "phoneNumber"
                                value={userInfo.phoneNumber}
                                onChange={handleChange}
                            />
                        ) : (
                            <span className={styled.data}>{userInfo.phoneNumber}</span>
                        )}
                    </div>
                    <div style={{display: 'none'}}>
                        <span className={styled.label}>진료항목</span>
                        {editMode ? (
                            <input
                                className={styled.basic_input}
                                type="text"
                                name = "phoneNumber"
                                value={userInfo.phoneNumber}
                                onChange={handleChange}
                            />
                        ) : (
                            <div className={styled.tag_con}>
                                {userInfo.tags.length === 0 ? <></>: 
                                userInfo.tags.map((tag)=>{return <div className="tag">{tag}</div>})}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className={styled.intro}>
                <span className={styled.label}>병원소개</span>
                <div className={styled.info_con}>
                    {editMode ? (
                    <textarea
                        className={styled.basic_textarea}
                        name="introduction"
                        value={userInfo.introduction}
                        onChange={handleChange}
                        />
                    ) : (
                        <p>{userInfo.introduction}</p>
                    )}
                </div>
            </div>
            <div className={styled.time}>
                <span className={styled.label}>병원 영업시간</span>
                <div className={styled.info_con}>
                    {editMode ? (
                        <textarea
                            className={styled.basic_textarea}
                            name="openingHours"
                            value={userInfo.openingHours}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{userInfo.openingHours.split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}<br/>
                            </React.Fragment>
                        ))}</p>
                    )}
                </div>
            </div>
        </div>
    </div>
    )
}

export default HospitalInformation